import type { InvoiceEmailDeliveryState } from "../../../../../types/neWebApi.types";
import { InvoiceState, InvoiceType } from "../../../../../types/neWebApi.types";
import { EMAIL_ERROR_STATES } from "../../PPAInvoicePage.constants";

export const STATUS_LABELS = {
  ready_to_create: "Bereit zum Erstellen",
  ready_to_send: "Versandbereit",
  delivered: "Zugestellt",
  corrected: "Storniert",
  error: "Fehler"
} as const;

export type InvoiceStatus = keyof typeof STATUS_LABELS;

/**
 * Derives a high-level invoice status from the combination of invoice state,
 * type, and email delivery state. Used for the status filter on the invoice table.
 *
 * Returns `null` for rows that don't map to a filterable status (e.g. in-progress sends).
 */
export function getInvoiceStatus(
  state: InvoiceState,
  invoiceType: InvoiceType,
  emailState: InvoiceEmailDeliveryState | null
): InvoiceStatus | null {
  if (state === InvoiceState.ready && invoiceType === InvoiceType.Draft) {
    return "ready_to_create";
  }

  if (state === InvoiceState.ready && !emailState) {
    return "ready_to_send";
  }

  if (
    state === InvoiceState.ready &&
    emailState &&
    EMAIL_ERROR_STATES.has(emailState)
  ) {
    return "error";
  }

  if (state === InvoiceState.delivered) {
    return "delivered";
  }

  if (state === InvoiceState.corrected) {
    return "corrected";
  }

  return null;
}
